const MAIN_API_URL: string | undefined = import.meta.env.VITE_BASE_API_URL;
const NA_API_URL: string | undefined = import.meta.env.VITE_API_URL_NA;

export const APP_URL_NA: string = import.meta.env.VITE_APP_URL_NA;

const hostname =
  typeof window === "undefined" ? "" : (window.location?.hostname ?? "");

/** True when this bundle is being served by the NA instance for its stage. */
export const IS_NA_INSTANCE: boolean =
  !!APP_URL_NA && hostname === new URL(APP_URL_NA).hostname;

if (!MAIN_API_URL) {
  throw new Error(
    `API URL is not configured for host "${hostname}": set VITE_BASE_API_URL`
  );
}

if (IS_NA_INSTANCE && !NA_API_URL) {
  throw new Error(
    `NA API URL is not configured for host "${hostname}": set VITE_API_URL_NA`
  );
}

export const BASE_API_URL: string =
  IS_NA_INSTANCE && NA_API_URL ? NA_API_URL : MAIN_API_URL;

// The NA instance runs with restricted egress and cannot reach Cognito, so auth
// requests are sent to the main API for the same stage instead.
export const AUTH_API_URL: string = MAIN_API_URL;

export const WS_URL: string = `${BASE_API_URL.replace(/^http/, "ws")}/events`;
